import { useCallback,useEffect, useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { fetchUserAclEntriesDetails } from 'common/services/api/Acls/AclEntries.thunk';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useFetchUserAclEntriesDetailsWithLicenseInfo = (item: {
	tenantId: string,
	userId: string,
	isLicenseRequired?: boolean
}) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { tenantId, userId, isLicenseRequired } = item;

    const fetchAclEntriesDetailsWithLicenseInfo = useCallback(() => {
        setProcessing(true);
        dispatch(fetchUserAclEntriesDetails({ tenantId, userId }))
            .unwrap()
            .then((response) => {
                dispatch(setRows(response));
            })
            .catch((error) => {
                dispatch(setRows([]));
                handleListFetchError(extractStatusCode(error.message), 'ACL Entries', enqueueSnackbar);
            })
            .finally(() => {
                setProcessing(false);
            });
    }, [tenantId, userId, isLicenseRequired]);


    useEffect(() => {
        if(isLicenseRequired) {
            fetchAclEntriesDetailsWithLicenseInfo();
        }
    }, [fetchAclEntriesDetailsWithLicenseInfo, isLicenseRequired]);

    const refreshUserAclEntriesDetailsWithLicenseInfo = () => fetchAclEntriesDetailsWithLicenseInfo();

    return {
        aclEntriesWithLicenseInfoProcessing: processing,
        refreshUserAclEntriesDetailsWithLicenseInfo
    };
};
